import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import Courts from './Courts';
import ContactAdmin from './ContactAdmin';
import Clubhouse from './Clubhouse';
import { GiTennisCourt } from "react-icons/gi";
import { MdPeople, MdHome } from "react-icons/md";

const ClubManagement = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Box>
            <Paper sx={{ p: 2, mb: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h5" component="h1" color="primary">
                        Vereinsverwaltung
                    </Typography>
                </Box>
                <Tabs 
                    value={tabValue} 
                    onChange={handleTabChange} 
                    indicatorColor="primary" 
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Vorstand & Kontakt" icon={<MdPeople />} iconPosition={isMobile ? "top" : "start"} />
                    <Tab label="Clubheim" icon={<MdHome />} iconPosition={isMobile ? "top" : "start"} />
                    <Tab label="Plätze" icon={<GiTennisCourt />} iconPosition={isMobile ? "top" : "start"} />
                </Tabs>
            </Paper>

            <Box sx={{ mt: 2 }}>
                {tabValue === 0 && <ContactAdmin />}
                {tabValue === 1 && <Clubhouse />}
                {tabValue === 2 && <Courts />}
            </Box>
        </Box>
    );
};

export default ClubManagement;
